module.exports = __webpack_public_path__ + "img/p16.fb3f90c1.png";